<template>
  <b-modal title="Informações Sobre o Profissional" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Nome:" label-for="nome" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="nome" v-model="editing.nome" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="3" label-align-sm="right">
            <b-form-textarea id="descricao" v-model="editing.descricao" rows="3" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Carimbo:" label-cols-sm="3" label-align-sm="right">
            <b-form-file
              type="file"
              class="text-left mt-1"
              v-model="arquivo"
              placeholder="Solte as fotos do carimbo .png"
              drop-placeholder="Solte o arquivo do carimbo .png"
              accept=".png"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import Profissional from "@/models/Profissional";
import Notificacao from "@/models/Notificacao";
import { useSgcqStore } from "@/stores/SgcqStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import Files from "@/http/files";

export default {
  name: "ModalDeEdicaoDeProfissional",

  data() {
    return {
      editing: new Profissional(),
      show: false,
      files: new Files(this.$http),
      arquivo: null,
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.profissionalStore.ALTERAR_PROFISSIONAL(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Profissional salvo no SGCQ com sucesso!", "Excelente!", "success"));
          if (this.arquivo != null) {
            const filename = this.editing.id + ".png";
            let formData = new FormData();
            formData.append("name", this.arquivo.name);
            formData.append("file", this.arquivo);
            this.files.uploadStamp(filename, formData);
          }
        });
      } else {
        this.profissionalStore
          .CADASTRAR_PROFISSIONAL(this.editing)
          .then(() => this.store.NOTIFICAR(new Notificacao("Profissional salvo no SGCQ com sucesso!", "Excelente!", "success")));
      }
      this.show = !this.show;
    },

    call(profissional) {
      this.editing = profissional;
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const profissionalStore = useProfissionalStore();

    return {
      store,
      profissionalStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
